<template>
  <div class="privacyStyles">
    <h1>用户许可协议</h1>
    <privacyVue class="content" />
  </div>
</template>

<script>
import privacyVue from "./compontent/privacy.vue";
export default {
  components: { privacyVue }
};
</script>

<style lang="scss" scoped>
.privacyStyles{
  padding: 10px;
  overflow-y: auto;
  h1{
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    margin: 10px 0;
  }
  .content{
    width: 100%;
    height: calc(100% - 40px);
  }
}
</style>
